<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单与报名</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>
      <!-- 搜索区域 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input 
            placeholder="订单编号" 
            v-model="searchQuery.order_no" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input 
            placeholder="活动标题" 
            v-model="searchQuery.activity_title" 
            clearable 
            @clear="handleSearch()" 
            @keyup.enter.native="handleSearch()"
            size="medium">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="searchQuery.status" placeholder="订单状态" @change="handleSearch()" size="medium">
            <el-option :value="0" label="待支付"></el-option>
            <el-option :value="1" label="已支付"></el-option>
            <el-option :value="2" label="已取消"></el-option>
            <el-option :value="3" label="已退款"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="searchQuery.is_manual" placeholder="创建方式" @change="handleSearch()" size="medium">
            <el-option :value="true" label="员工创建"></el-option>
            <el-option :value="false" label="用户报名"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
          <el-button type="success" plain @click="createOrder()" size="medium">创建订单</el-button>
        </el-col>
      </el-row>

      <!-- 订单列表 -->
      <el-table :data="orderList" style="width: 100%" border stripe>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="desc-card">
              <el-row :gutter="20">
                <el-col v-for="n in scope.row.participants_count" :key="n" :span="24 / Math.min(scope.row.participants_count, 4)" class="desc-participant-col">
                  <el-card class="desc-participant-card">
                    <template v-if="scope.row.participants && scope.row.participants[n-1]">
                      <div class="desc-title">
                        <span class="desc-title-bar"></span>
                        <span>报名人{{ n }}</span>
                        <span class="desc-title-flex-spacer"></span>
                        <el-progress
                          class="desc-progress-bar"
                          :percentage="getProgress(scope.row.participants[n-1])"
                          :color="customColors"
                          :show-text="false"
                          :stroke-width="4"
                        />
                      </div>
                      <el-descriptions :column="1" size="small" border>
                        <el-descriptions-item label="姓名">{{ scope.row.participants[n-1].name || '- - -' }}</el-descriptions-item>
                        <el-descriptions-item label="性别">{{ formatGender(scope.row.participants[n-1].gender) }}</el-descriptions-item>
                        <el-descriptions-item label="年龄">{{ scope.row.participants[n-1].age || '-' }}岁</el-descriptions-item>
                        <el-descriptions-item label="手机号">{{ scope.row.participants[n-1].phone || '- - -' }}</el-descriptions-item>
                        <el-descriptions-item label="身份证号">{{ scope.row.participants[n-1].id_card_number || '- - -' }}</el-descriptions-item>
                      </el-descriptions>
                    </template>
                    <template v-else>
                      <div class="desc-title"><span class="desc-title-bar"></span>报名人{{ n }}</div>
                      <div class="desc-unfilled">
                        <i class="el-icon-warning-outline"></i>
                        <span>未填写报名人信息</span>
                      </div>
                    </template>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="#" type="index" width="40" align="center"></el-table-column>
        <el-table-column label="订单编号"  width="150" prop="order_no" align="center"></el-table-column>
        <el-table-column label="活动标题" prop="title_cn" align="center"></el-table-column>
        <el-table-column label="订单金额" width="120" align="center">
          <template slot-scope="scope">
            <span style="display: flex; flex-direction: column; align-items: center;">
              <span>¥{{ scope.row.amount }}</span>
              <span v-if="scope.row.paid_amount > 0" style="color: #52c41a; font-size: 10px;">
                ¥{{ scope.row.paid_amount }}
              </span>
              <span v-else style="color: #aaa; font-size: 9px;">
                未支付
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="报名人数" width="70" align="center">
          <template slot-scope="scope">{{ scope.row.participants_count }} 人</template>
        </el-table-column>
        <el-table-column label="是否填写" width="70" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="!scope.row.participants || scope.row.participants.length === 0" content="未填写" placement="top">
              <i class="el-icon-circle-close" style="color: #ff4d4f; font-size: 15px;"></i>
            </el-tooltip>
            <el-tooltip v-else-if="scope.row.participants.length < scope.row.participants_count" content="部分填写" placement="top">
              <i class="el-icon-warning-outline" style="color: #faad14; font-size: 15px;"></i>
            </el-tooltip>
            <el-tooltip v-else-if="scope.row.participants.length === scope.row.participants_count" content="已填写" placement="top">
              <i class="el-icon-circle-check" style="color: #52c41a; font-size: 15px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="微信昵称" width="100" prop="nickname" align="center"></el-table-column>
        <el-table-column label="绑定手机号" width="120" prop="phone" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="150" align="center"></el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="查看详情" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" icon="el-icon-view" @click="viewOrder(scope.row.order_no)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import filterMixin from '@/utils/filter.js'

export default {
  name: 'Orders',
  mixins: [filterMixin],
  data() {
    return {
      sessionKey: 'OrderListSearch',
      filterFetchMethod: 'fetchOrders',
      total: 0,
      pageNum: 1,
      pageSize: 10,
      orderList: [],
      searchQuery: {
        order_no: '',
        activity_title: '',
        status: null,
        is_manual: null
      },
      statusInfo: {
        0: { type: 'danger', text: '待支付' },
        1: { type: 'primary', text: '已支付' },
        2: { type: 'info', text: '已取消' },
        3: { type: 'warning', text: '已退款' }
      },
      customColors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#1989fa', percentage: 60},
        {color: '#13c2c2', percentage: 90},
        {color: '#5cb87a', percentage: 100}
      ]
    }
  },
  created() {
    this.fetchOrders()
  },
  methods: {
    fetchOrders() {
      this.$http({
        method: 'get',
        url: 'orders/',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.orderList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取订单列表失败')
      })
    },

    handleSearch() {
      this.pageNum = 1
      this.fetchOrders()
    },

    resetSearch() {
      this.searchQuery = { order_no: '', activity_title: '', status: null, is_manual: null }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchOrders()
    },
    
    createOrder() {
      this.$router.push(`/admin/order/create`)
    },

    getStatusText(status) {
      return this.statusInfo[status]?.text || '未知'
    },

    getStatusType(status) {
      return this.statusInfo[status]?.type || 'info'
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchOrders()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchOrders()
    },

    viewOrder(id) {
      this.$router.push(`/admin/order/details/${id}`)
    },

    formatGender(gender) {
      if (gender === 0 || gender === '0') return '男';
      if (gender === 1 || gender === '1') return '女';
      return gender || '-';
    },

    getProgress(participant) {
      if (!participant) return 0;
      const fields = [
        'age', 'blood_type', 'dietary_taboo', 'drug_allergy', 'favorite_color', 'favorite_subject',
        'gender', 'grade', 'height', 'hobbies', 'household', 'id_card_back', 'id_card_front',
        'id_card_number', 'id_card_type', 'learning_desc', 'name', 'personality_traits', 'phone',
        'school', 'sleep_status', 'weak_subject', 'weight'
      ];
      let filled = 0;
      fields.forEach(key => {
        const val = participant[key];
        if (val !== null && val !== undefined && val !== '') filled++;
      });
      return Math.round((filled / fields.length) * 100);
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}
.el-table {
  margin-top: 15px;
}
.el-pagination {
  margin-top: 15px;
}
.desc-card {
  padding: 0 20px;
}
.desc-participant-col {
  margin-bottom: 20px;
}
.desc-participant-card {
  min-width: 200px;
  max-width: 300px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.desc-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 12px;
  color: #333;
  letter-spacing: 1px;
}
.desc-title-bar {
  display: inline-block;
  width: 3px;
  height: 16px;
  background: #409EFF;
  border-radius: 2px;
  margin-right: 10px;
}
.desc-title-flex-spacer {
  flex: 1;
}
.desc-title > .desc-progress-bar {
  margin-left: 16px;
  width: 50px;
  min-width: 60px;
  flex-shrink: 0;
}
.desc-progress-bar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.desc-progress-bar {
  width: 40%;
  vertical-align: middle;
}
.desc-unfilled {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d46b08;
  background: #fff7e6;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  padding: 18px 0;
  margin: 8px 0;
  letter-spacing: 1px;
}
.desc-unfilled .el-icon-warning-outline {
  font-size: 16px;
  margin-right: 8px;
}
</style>
